import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import ManageSubscriptionsComponent from '@app/components/manage-subscriptions/list';

const ManageSubscription: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageTitle>Manage Subscription</PageTitle>
      <ManageSubscriptionsComponent />
    </>
  );
};

export default ManageSubscription;
